module.exports = __webpack_public_path__ + "img/1.cab01a39.jpg";